import { render, staticRenderFns } from "./CompanyTeamInvitation.vue?vue&type=template&id=3230d6a2"
import script from "./CompanyTeamInvitation.vue?vue&type=script&lang=js"
export * from "./CompanyTeamInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports